import { AxiosResponse } from 'axios';
import { client } from '../../../shared/services/client';
import { LobPolicyTypeMapping } from '../Model/LobPolicyTypeMapping';

const policyBaseKey = 'policy';

export default class PolicyManagementAPI {
    getLobPolicyTypeMappings = async (): Promise<LobPolicyTypeMapping[]> => {
        client.setBaseURLForService(policyBaseKey);
        const response: AxiosResponse<LobPolicyTypeMapping[]> = await client.get('/Policy/GetLobPolicyTypeMappings');
        return response.data;
    };
}